import {
  getFilteredStops,
  getStopFilters,
  getSortedStops,
} from "../../../selectors/ui/routeDetail";
import {
  getNewSelectedStopNumbers,
  getNextSelectedByFilterStops,
  getSatisfyCriteriaStopIds,
  getStopsToSelect,
} from "../../../../models/routeDetail";
import { getNextRouteFilters } from "../../../../features/routeDetail/model";
import { getRouteDetail } from "../../../selectors/route";
import { setDefaultOrder } from "./stopListOrder";
import { resetSelectedParcels } from "./selectedParcels";
import { removeCriteriaById } from "../../../../features/routeDetail/criteriaModel";

const UPDATE_FILTERS = "TOGGLE_FILTER";
const UPDATE_SELECTED_STOPS = "UPDATE_SELECTED_STOPS";
const SET_PREVIOUS_STOP_INDEX = "SET_PREVIOUS_STOP_INDEX";
const CLEAR_FILTERS = "CLEAR_FILTERS";
const CLEAR_SELECTION = "CLEAR_SELECTION";
const SET_CRITERIA = "SET_CRITERIA";

export const actionTypes = {
  UPDATE_FILTERS,
  UPDATE_SELECTED_STOPS,
  SET_PREVIOUS_STOP_INDEX,
  CLEAR_FILTERS,
  CLEAR_SELECTION,
  SET_CRITERIA,
};

export const updateFilters = (filters, stopIds) => ({
  type: UPDATE_FILTERS,
  payload: {
    filters,
    stopIds,
  },
});

export const updateSelectedStops = (stopIds) => ({
  type: UPDATE_SELECTED_STOPS,
  payload: stopIds,
});

export const setPreviousStopIndex = (idx) => ({
  type: SET_PREVIOUS_STOP_INDEX,
  data: idx,
});

export const clearSelection = () => ({
  type: CLEAR_SELECTION,
});

export const clearFilters = () => ({
  type: CLEAR_FILTERS,
});

export const clearSelectedResetOrder = () => (dispatch) => {
  dispatch(clearSelection());
  dispatch(setDefaultOrder());
  dispatch(resetSelectedParcels());
};

export const toggleFilter = (id) => (dispatch, getState) => {
  const state = getState();
  const { filters } = getStopFilters(state);
  const { stop: stops } = getRouteDetail(state);

  const nextFilters = getNextRouteFilters(filters, id);
  const selectedStopIds = getNextSelectedByFilterStops(nextFilters, stops);

  dispatch(updateFilters(nextFilters, selectedStopIds));
};

// export const selectStops = (stops) => (dispatch) => {
//   dispatch(clearFilters());
//   dispatch(updateSelectedStops(stops.map((stop) => stop.stopNumber)));
// };

export const toggleSelectedStop = (stop, stopIndex, shiftKey) => (
  dispatch,
  getState
) => {
  const state = getState();
  const {
    previousStopIndex,
    filters,
    manuallySelectedStops,
    criteria,
  } = getStopFilters(state);
  const filteredStops = getFilteredStops(state);
  const sortedStops = getSortedStops(state);

  if (!stop || !+stop.stopNumber) {
    return dispatch(setPreviousStopIndex(null));
  }

  const stopsToSelect = getStopsToSelect({
    stopId: stop.stopId,
    stops: sortedStops,
    previousStopIndex,
    stopIndex,
    shiftKey,
  });

  const isFilter = !!filters.length;

  const newSelectedStops = getNewSelectedStopNumbers({
    stops: filteredStops,
    selectedStops: manuallySelectedStops,
    stopsToSelect,
    isFilter,
  });

  if (isFilter || criteria.length) {
    dispatch(clearSelection());
  }
  dispatch(setPreviousStopIndex(stopIndex));
  dispatch(updateSelectedStops(newSelectedStops));
};

export const setCriteria = (criteria) => (dispatch, getState) => {
  const { stop: stops } = getRouteDetail(getState());
  const selectedStopIds = criteria.length
    ? getSatisfyCriteriaStopIds(criteria, stops)
    : [];
  dispatch({
    type: SET_CRITERIA,
    data: { criteria, selectedStopIds },
  });
};

export const removeCriteria = (id) => (dispatch, getState) => {
  const { criteria } = getStopFilters(getState());
  const nextCriteria = removeCriteriaById(criteria, id);
  dispatch(setCriteria(nextCriteria));
};
